// PROEVE-UDLOEB-V1 (31-10-2026): ren logik til Campus' port. Ingen React, ingen Firebase: testes i node.
// Proeve slut = subscriptionStatus 'expired' OG trialExpiredAt findes (kontrakt reference/kontrakt/proeve_udloeb.md).
// Restance er noget andet (membershipStatus 'past_due') og beholder sin egen tekst og knap.

export type GateKind = 'banned' | 'pay' | 'trial' | 'closed';

export interface GateInput {
  role?: string;
  isBanned?: boolean;
  hasHallsAccess?: boolean;
  hasOnlineClassroomAccess?: boolean;
  memberStatus?: string;
  subscriptionStatus?: string;
  trialExpiredAt?: unknown;
}

const STAFF = ['admin', 'superadmin', 'guardian'];
export const EMPORIUM = 'https://norewyn.com/emporium';

export const erProeveSlut = (subscriptionStatus?: string, trialExpiredAt?: unknown): boolean =>
  subscriptionStatus === 'expired' && !!trialExpiredAt;

/** null = porten er aaben. Ellers arten af vaeggen. Raekkefoelge: banned, trial, closed, pay (restance). */
export const gateKind = (i: GateInput): GateKind | null => {
  if (STAFF.includes(String(i.role || ''))) return null;
  if (i.isBanned) return 'banned';
  const payOk = ['active', 'lifetime'].includes(i.memberStatus || '');
  const hasHalls = i.hasHallsAccess === true;
  if (!hasHalls && !i.hasOnlineClassroomAccess && erProeveSlut(i.subscriptionStatus, i.trialExpiredAt)) return 'trial';
  if (!hasHalls) return 'closed';
  if (!payOk) return 'pay';
  return null;
};

export const emporiumLink = (produkt?: string): string =>
  produkt ? `${EMPORIUM}?produkt=${encodeURIComponent(produkt)}` : EMPORIUM;

export const gateHref = (kind: GateKind, produkt?: string): string =>
  kind === 'pay' ? 'https://norewyn.com/profile' : kind === 'trial' ? emporiumLink(produkt) : EMPORIUM;

export type TrialLang = 'da' | 'en' | 'no';
// Campus har ingen sprogmekanisme (GATE_TXT er kun dansk); proevevaeggen vaelger da/en/no ud fra browserens sprog, ellers da.
export const TRIAL_TXT: Record<TrialLang, { title: string; parent: string; student: string; cta: string }> = {
  da: { title: 'Prøven er slut', parent: 'Vælg medlemskab i Handelsposten', student: 'Bed din forælder om at vælge medlemskab', cta: 'Vælg medlemskab' },
  en: { title: 'The trial is over', parent: 'Choose a membership in the Marketplace', student: 'Ask your parent to choose a membership', cta: 'Choose membership' },
  no: { title: 'Prøven er slutt', parent: 'Velg medlemskap i Handelsposten', student: 'Be forelderen din om å velge medlemskap', cta: 'Velg medlemskap' },
};
export const trialLang = (nav?: string): TrialLang => {
  const l = String(nav || '').toLowerCase().slice(0, 2);
  return l === 'en' ? 'en' : (l === 'no' || l === 'nb' || l === 'nn') ? 'no' : 'da';
};
